import React from 'react';
import {MINUS_SIGN} from "../../../constants/text";

const SupplyPhaseRules = () => {
  const farm = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/farm.699e6dfc.png'}
    alt={'Ферма'}
    title={'Ферма'}
  />;
  const barracks = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;
  const supply = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;
  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;
  const distance = <img
    className={'policy-description-icon'}
    src={'/img/icons/distance.png'}
    alt={'Дальность'}
    title={'Дальность'}
  />;
  const mountain = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/mountains/mountain_rock_1.862dc5c3.png'}
    alt={'Гора'}
    title={'Гора'}
  />;
  const speed = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/speed.png'}
    alt={'Перемещение'}
    title={'Перемещение'}
  />;
  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const maneuver = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/maneuver_black.png'}
    alt={'Маневр'}
    title={'Маневр'}
  />;

  return (
    <div className="rules-page_content">
      <h2 className="rules-page_title text-supply">
        <img
          className={'rules-page_title-icon'}
          src={'/img/icons/supply.png'}
          alt={''}
          aria-hidden={'true'}
        />
        Фаза Снабжения
      </h2>

      <div className="rules-page_section">
        <p>
          Если игрок владеет фермами {farm}, то в этой фазе он может распределить произведенные ими единицы
          снабжения {supply} между своими отрядами {unit}.
        </p>
        <p>
          Для этого к желаемому отряду мысленно строится <b>путь снабжения</b> — непрерывный путь по не пустым
          ячейкам поля от фермы до отряда, длиной не более {distance} 5 ячеек (то есть не более 4 ячеек между фермой и
          отрядом). Сам отряд при этом может находиться на пустой ячейке. Путь не должен проходить по ячейкам гор
          {mountain} или зоны контроля отрядов противника.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Порядок фазы</h2>
        <p>
          В сетевой игре фаза Снабжения проходит <b>одновременно</b>: ходы всех игроков идут параллельно, очереди
          нет. В начале фазы снабжение {supply} каждого игрока распределяется автоматически. Если выбирать не из чего
          (например, каждая работающая ферма {farm} дотягивается только до одного отряда {unit}), ход игрока сразу завершается автоматически. Иначе до завершения своего хода
          распределение можно изменить. Завершив ход, игрок уже не может изменить свое распределение и ждет остальных.
        </p>
        <p>
          <b>В сетевой игре результат снабжения применяется ко всем игрокам единовременно — только когда фазу Снабжения
            завершат все игроки.</b> До этого размеры отрядов {unit} не меняются: рост, потеря размера и гибель отрядов
          происходят у всех разом.
        </p>
        <p>
          В сетевой игре время фазы общее для всех — 40 секунд (20 секунд в быстром режиме) от ее начала, и оно не
          продлевается, когда кто-то завершает ход. Когда время выходит, ход не успевших игроков завершается автоматически с тем
          распределением, которое у них есть. За игроков, покинувших матч, ход тоже завершается автоматически. Если в
          матче выключен таймер ходов, фаза ждет, пока ход завершат все.
        </p>
        <p>
          В сетевой игре, пока фаза идет, пути снабжения, фермы {farm} и казармы {barracks} всех игроков проверяются по
          отрядам, стоявшим на поле в начале фазы. Отряд противника, который погибнет без снабжения, до конца фазы продолжает
          перекрывать пути снабжения и блокировать строения. Исключение — отряды, нанятые крысолюдами за снабжение: они
          появляются на поле сразу, но до конца фазы ничего не блокируют.
        </p>
        <p>
          В локальной игре, обучении и сюжетной кампании игроки проходят фазу Снабжения по очереди, и результат
          применяется в конце хода каждого игрока. Поэтому следующий игрок уже видит итог предыдущих: погибшие отряды
          ничего не блокируют, а нанятые за снабжение — блокируют.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Базовое снабжение</h2>
        <p>Для базового снабжения отряду необходима 1 единица снабжения {supply}. Если отряд ее получил, он
          называется <b>снабженным</b>.</p>
        <ul>
          <li>Снабженный отряд (не в казарме) — размер увеличивается на +1.</li>
          <li>Снабженный отряд в казарме {barracks} — размер увеличивается на +2.</li>
          <li>Не снабженный отряд — размер уменьшается на {MINUS_SIGN}2.</li>
        </ul>
        <p>
          Платить монеты за увеличение размера отрядов в этой фазе не нужно. Игрок может приоритезировать снабжение
          любых желаемых отрядов, в том числе оставляя некоторые отряды без снабжения ради дополнительного снабжения
          других.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Передача снабжения через цепочку ферм</h2>
        <p>
          Ферма {farm} может передавать свое снабжение {supply} отрядам через другие фермы, если от одной фермы к
          другой можно построить путь снабжения. Цепочка передачи может проходить через неограниченное количество
          передающих ферм. Одна ферма может передавать неограниченное количество снабжения от других ферм.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Дополнительное снабжение</h2>
        <p>
          Если отряд уже получил базовую единицу снабжения {supply}, его можно снабдить <b>дополнительно</b>, если
          есть возможность построить до него путь снабжения от фермы с неизрасходованной единицей снабжения
          (полностью по аналогии с базовым снабжением, в том числе через другие фермы по цепочке).
        </p>
        <p>
          Дополнительное снабжение стоит 1 единицу снабжения {supply}. Жетон дополнительного снабжения остается у
          отряда до конца раунда и дает в фазе Войны одно из преимуществ (на выбор):
        </p>
        <ul>
          <li>Переместиться {speed} на 1 ячейку дальше на этапе перемещения.</li>
          <li>Перебросить любые кости урона {damage} в ближнем бою или стрельбе.</li>
          <li>Переместиться на 1 ячейку на этапе маневра {maneuver}.</li>
        </ul>
        <p>
          Отряд может использовать только 1 из этих возможностей — после чего жетон сразу убирается. Неизрасходованные
          жетоны дополнительного снабжения убираются с поля в конце раунда.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Великаны</h2>
        <p>
          Великаны могут получать базовое снабжение {supply} неограниченное количество раз за один и тот же
          отряд за ход — каждая полученная единица снабжения увеличивает размер отряда как обычно (+1, или +2 в
          казарме {barracks}).
        </p>
        <p>
          Дополнительное снабжение для великанов стоит не 1, а 4 единицы снабжения {supply} и по-прежнему даёт не
          рост размера, а один из обычных бонусов дополнительного снабжения (переброс урона, доп. перемещение или
          манёвр) — не более 1 раза за отряд за ход, как и у остальных фракций.
        </p>
      </div>
    </div>
  );
};

export default SupplyPhaseRules;
